import { createAction } from '@reduxjs/toolkit'

export const SUBSCRIPTION = 'SUBSCRIPTION'

type SubscriptionResponse = { id: string; change: string; before: any; after: any }
type SubscriptionData = { modelKey: string; response: SubscriptionResponse }
export const setSubscriptionDataAction = createAction<SubscriptionData>(SUBSCRIPTION)
